<template>
  <div
    :class="$style.root"
    :data-has-caption="includeCaption && activeSlideCaption ? '' : null"
  >
    <CoreSwiperComponent
      @set-active-index="setActiveIndex"
      :slideToIndex="slideToIndex"
    >
      <SwiperSlide
        v-for="(image, index) in images"
        :key="image?.id || index"
      >
        <CoreImageComponent
          :image="image?.attributes"
          :showCaption="false"
        />
      </SwiperSlide>
    </CoreSwiperComponent>

    <CoreImageCarouselCaptionComponent
      v-if="includeCaption && activeSlideCaption"
      :caption="activeSlideCaption"
    />
  </div>
</template>

<script setup>
import { SwiperSlide } from 'swiper/vue'
const { locale: currentLocale } = useI18n()

const props = defineProps({
  images: {
    type: Array
  },
  includeCaption: {
    type: Boolean,
      default: true
  },
  slideToIndex: Number
})

const emit = defineEmits(['setActiveIndex'])
const activeIndex = ref(0)
const setActiveIndex = (index) => {
  activeIndex.value = index
  emit('setActiveIndex', index)
}

const activeSlideCaption = computed(() => {
  const attributes = props?.images[activeIndex?.value]?.attributes
  return currentLocale.value === 'en' ? attributes?.captionEn || attributes?.caption : attributes?.caption
})
</script>

<style module>
.root [data-orientation="landscape"] {
  --base--image--max-aspect-ratio: var(--core-image-carousel--aspect-ratio, 9 / 7);
  --base--image--object-fit: contain;
}

.root [data-orientation="square"] {
  --base--image--max-aspect-ratio: var(--core-image-carousel--aspect-ratio, 9 / 7);
  --base--image--object-fit: contain;
}

.root [data-orientation="portrait"] {
  --base--image--max-aspect-ratio: var(--core-image-carousel--aspect-ratio, 9 / 7);
  --base--image--object-fit: contain;
}

.root :global(.swiper) {
  position: relative;
  /* NOTE to compensate for miscalculations */
  clip-path: inset(0 1px 0 1px);
}

.root :global(.swiper-wrapper) {
  /* NOTE to overwrite height transition */
  transition-property: transform !important;
}
</style>
